import React, { useEffect } from "react";
import "./Preloader.css";

interface ThemeColors {
  background: string;
  heart: string;
  text: string;
  accent: string;
}

interface Props {
  bride: string;
  groom: string;
  colors: ThemeColors;  
  durationMs?: number;
  onFinish: () => void;
}

const Preloader: React.FC<Props> = ({ bride, groom, colors, durationMs = 1000, onFinish }) => {
  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--bg-color", colors.background);
    root.style.setProperty("--heart-color", colors.heart);
    root.style.setProperty("--text-color", colors.text);
    root.style.setProperty("--accent-color", colors.accent);
  }, [colors]);

  useEffect(() => {
    const timer = setTimeout(() => {
      onFinish();
    }, durationMs);
    return () => clearTimeout(timer);
  }, [durationMs, onFinish]);

  return (
    <div className="loading-heart">
      <svg viewBox="-50 -50 612 612" className="heart-svg">
        <path
          className="heart-path"
          d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3
             C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9
             l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8
             c56.3-58.1 53-154.3-9.8-207.9z"
        />
      </svg>

      <div className="preloader-title">
        {bride}<br />
        <small>&amp;</small><br />
        {groom}
      </div>

      <div className="preloader-sub">Un instant de patience, l'amour se dévoile...</div>
    </div>
  );
};

export default Preloader;